module.exports = __webpack_public_path__ + "img/pet-sq.160c1994.svg";